import { defineMessages } from 'react-intl'

export default defineMessages({
  noOptions: {
    id: 'containers.EmbeddedDealPage.components.Usage.noOptions',
    defaultMessage: 'No countries called',
  },
  searching: {
    id: 'containers.EmbeddedDealPage.components.Usage.searching',
    defaultMessage: 'Searching for',
  },
  countries: {
    id: 'containers.EmbeddedDealPage.components.Usage.countries',
    defaultMessage: 'Countries',
  },
})
